var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',{attrs:{"ok-text":_vm.$t('add_button'),"cancel-text":_vm.$t('cancel_button'),"cancel-button-props":{
    props: {
      disabled: _vm.isCreating,
    }
  },"ok-button-props":{
    props: {
      disabled: _vm.isCreating || !_vm.label,
      loading: _vm.isCreating
    }
  }},on:{"ok":_vm.onOk},model:{value:(_vm.modalIsOpen),callback:function ($$v) {_vm.modalIsOpen=$$v},expression:"modalIsOpen"}},[_c('text-input',{attrs:{"setup":{
      'func': _vm.modelSetter,
      'args': {
        'model': this,
        'key': 'label',
        'prefix': 'create_new_',
        'validation': 'required',
      },
    }},on:{"pressEnter":function($event){!_vm.label ? false : _vm.onOk()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }